import { api } from './baseApi';
export var favoritesApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getUserFavorites: builder.query({
                query: function (_a) {
                    var userId = _a.userId;
                    return ({
                        url: "/favorites/".concat(userId),
                        method: 'GET',
                    });
                },
                providesTags: ['Restaurants'],
            }),
        });
    },
    overrideExisting: false,
});
export var useGetUserFavoritesQuery = favoritesApi.useGetUserFavoritesQuery;
